import { Clock } from "lucide-react";

import { CHANNEL_DISPLAY_NAME, fmtExactZoned, TELEGRAM_AWAITING_LINK } from "./threadFormat";

// A not-yet-sent sequence step, shown as a centred pill rather than a bubble
// so the recruiter can see what is coming without it reading as a real
// message someone already sent.
//
// The send time is named with its zone. A pill sits below the day dividers,
// so nothing above it places the instant, and the send window these steps run
// on is expressed in UTC while the recruiter reading them is not.
//
// A Telegram step for a candidate who has not joined the bot is held while
// the emailed invite does its work (`telegram_awaiting_link`, set by
// sender._await_telegram_link); its time is when the wait gives up.
const UpcomingPill = ({ item }) => {
  const awaitingLink = item.last_error === TELEGRAM_AWAITING_LINK;
  const channel = CHANNEL_DISPLAY_NAME[item.channel] || item.channel;
  return (
    <div className="flex justify-center px-1 my-1">
      <div className="inline-flex items-center gap-2 rounded-full border border-dashed border-tone-blue/40 bg-tone-blue-soft px-3 py-1">
        <Clock size={12} className="text-tone-blue shrink-0" aria-hidden="true" />
        <span className="text-xs text-text-secondary">
          {awaitingLink ? "Waiting for them to join Telegram · invite emailed" : `Upcoming ${channel} follow-up`}
          {item.sequence_name ? ` · ${item.sequence_name}` : ""}
          {item.scheduled_for ? ` · ${awaitingLink ? "until " : ""}${fmtExactZoned(item.scheduled_for)}` : ""}
        </span>
      </div>
    </div>
  );
};

export default UpcomingPill;
